module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h1>Pick an exisiting file</h1>\n<div class="list-hook scrollbox"></div>\n<a href="#" class="button button-secondary abandon closeButton">Cancel</a>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./base/templates/attachments/existing_dialog.html
// module id = 281
// module chunks = 0